import { UserDTOV1 } from '../swagger-api-v1';

export class User {
  constructor(
    public deviceCount: number,
    public profileCount: number
  ) {}

  public static fromDTO(dto: UserDTOV1): User {
    return new User(dto.devicesCount, dto.profilesCount);
  }
}
